import React from "react";
import Dispatcher from "../../dispatcher";
import gadgets from "../gadgets/gadgets";

var Panel = require("./panel");

class PanelContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      activePanel: null,
      panelData: null,
      lastClick: null
    };

    this.stopPageChange = this.stopPageChange.bind(this);
    this._getPanelSettings = this._getPanelSettings.bind(this);
    this._buildGadget = this._buildGadget.bind(this);
    this._resizeReader = this._resizeReader.bind(this);
    this._togglePanel = this._togglePanel.bind(this);
    this._showPanel = this._showPanel.bind(this);
    this._showPanelUnlessAlreadyUp = this._showPanelUnlessAlreadyUp.bind(this);
    this._hideAllPanels = this._hideAllPanels.bind(this);
    this._hidePanel = this._hidePanel.bind(this);
    this._getGadgetClass = this._getGadgetClass.bind(this);
    this._loadSavedPanels = this._loadSavedPanels.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 5);
    Dispatcher.bind(Dispatcher.TOGGLE_PANEL, this._togglePanel);
    Dispatcher.bind(Dispatcher.HIDE_PANEL, this._hidePanel);
    Dispatcher.bind(Dispatcher.SHOW_PANEL, this._showPanel);
    Dispatcher.bind(
      Dispatcher.SHOW_UNSEEN_PANEL,
      this._showPanelUnlessAlreadyUp
    );
    Dispatcher.bind(Dispatcher.HIDE_ALL_PANELS, this._hideAllPanels);
    Dispatcher.bind(Dispatcher.LOAD_SAVED_PANELS, this._loadSavedPanels);
  }

  componentDidUpdate() {
    if (
      this.state.activePanel &&
      this.state.panelData &&
      !this.panelContainer
    ) {
      this.panelContainer = document.getElementById("panel-container");
      this.panelContainer.addEventListener("keyup", this.stopPageChange);
    }
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.TOGGLE_PANEL, this._togglePanel);
    Dispatcher.unbind(Dispatcher.HIDE_PANEL, this._hidePanel);
    Dispatcher.unbind(Dispatcher.SHOW_PANEL, this._showPanel);
    Dispatcher.unbind(
      Dispatcher.SHOW_UNSEEN_PANEL,
      this._showPanelUnlessAlreadyUp
    );
    Dispatcher.unbind(Dispatcher.HIDE_ALL_PANELS, this._hideAllPanels);
    Dispatcher.unbind(Dispatcher.LOAD_SAVED_PANELS, this._loadSavedPanels);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 5);
    this.panelContainer &&
      this.panelContainer.removeEventListener("keyup", this.stopPageChange);
  }

  stopPageChange(e) {
    switch (e.keyCode) {
      case 37:
        e.stopImmediatePropagation();
        break;
      case 39:
        e.stopImmediatePropagation();
        break;
      default:
        break;
    }
  }

  _getPanelSettings() {
    let panels = Fraction.Helpers.getDataObject("User.Persist.Panels");
    panels.allBooks = panels.allBooks || {};
    return panels;
  }

  _buildGadget(gadgetId, props) {
    gadgets.find(gadget => {
      gadget.active = false;
    });

    let gadget = gadgets.find(gadget => gadget.metadata().id === gadgetId);

    if (
      gadget.cachedPanel &&
      gadget.cachedPanel.props &&
      gadget.cachedPanel.props === this.props.isbn
    ) {
      // TODO: Looks like this can be deleted...
      // eslint-disable-next-line no-self-assign
      gadget.cachedPanel = gadget.cachedPanel;
    } else {
      gadget.cachedPanel = this._getGadgetClass(gadget, props);
    }
    return gadget;
  }

  _resizeReader(gadget) {
    delete Fraction.Helpers.getDataObject("User.Persist.Panels")[
      this.state.lastClick
    ];
    delete Fraction.Helpers.getDataObject("User.Persist.Panels")[
      gadget.metadata().id
    ];

    Dispatcher.emit(Dispatcher.BOOK_PLACEHOLDER_RESIZE);
    Dispatcher.emit(Dispatcher.PANEL_CHANGE, gadget);
  }

  _togglePanel(gadgetId, props) {
    let gadget = this._buildGadget(gadgetId);

    if (this.state.lastClick !== gadget.metadata().id) {
      this._showPanel(gadget);
      Fraction.Reporter.gaEvent("reader/panels/open", "", gadgetId);
    } else {
      this._hidePanel(gadgetId);
      Fraction.Reporter.gaEvent("reader/panels/close", "", gadgetId);
    }

    this._resizeReader(gadget);
    $("#" + gadgetId + "-button").focus();
  }

  _showPanel(gadget, props) {
    if (typeof gadget === "string") {
      gadget = this._buildGadget(gadget, props);
    }
    // For now, I want to ensure that if there was no enabled function, we still show the panel (aka labs)
    if (
      gadget.metadata().enabled &&
      !gadget.metadata().enabled(this.props.isbn)
    ) {
      return;
    }

    let currentBook = this.props.isbn;
    let key = gadget.metadata().id;
    let panelObject = this._getPanelSettings();

    panelObject[key] = Object.assign({}, this.state.panelData);
    gadget.active = true;
    panelObject[key] = {
      content: gadget.cachedPanel,
      title: gadget.metadata().name,
      identifier: key,
      keyobj: { key: key },
      config: panelObject[key + "_config"],
      closeCallback: this._togglePanel,
      hideHeader: gadget.metadata().hideHeader,
      noCache: gadget.metadata().noCache,
      titleButton: gadget.metadata().titleButton,
      titleButtonFunction: gadget.metadata().titleButtonFunction
    };
    panelObject["allBooks"][currentBook] = key;
    Fraction.Helpers.savePersist();

    this.props.hideMobileMenus();

    this.setState({
      panelData: panelObject[key],
      activePanel: gadget,
      lastClick: key
    });
    this._resizeReader(gadget);
    Fraction.Helpers.runAfterRender(() => {
      $("#panel-header-" + key).focus();
    });
  }

  _showPanelUnlessAlreadyUp(gadgetId, props) {
    this.state.lastClick !== gadgetId && this._showPanel(gadgetId, props);
  }

  _hideAllPanels() {
    if (this.state.activePanel) {
      this._hidePanel(this.state.activePanel.metadata().id);
    }
  }

  _hidePanel(gadgetId) {
    let gadget = gadgets.find(gadget => gadget.metadata().id === gadgetId);
    gadget.active = false;
    let panelObject = this._getPanelSettings();
    panelObject.allBooks[this.props.isbn] = null;
    Fraction.Helpers.savePersist();
    this.setState({ lastClick: null, activePanel: null, panelData: null });
    this._resizeReader(gadget);
  }

  _getGadgetClass(gadget, props = {}) {
    return (
      <gadget.class
        title={gadget.metadata().name}
        key={`${gadget.metadata().id}`}
        close={() => {
          this._togglePanel(gadget.metadata().id);
        }}
        query={props.query}
        isbn={this.props.isbn}
        {...props}
      />
    );
  }

  _loadSavedPanels() {
    if (!Fraction.Helpers.isSmallScreen()) {
      let panelObject = this._getPanelSettings();
      if (panelObject.allBooks[this.props.isbn]) {
        let gadget = gadgets.find(
          gadget =>
            gadget.metadata().id === panelObject.allBooks[this.props.isbn]
        );
        this._showPanel(panelObject.allBooks[this.props.isbn]);
        this._resizeReader(gadget);
      }
    }
  }

  render() {
    let panel = null;
    if (this.state.activePanel && this.state.panelData) {
      panel = (
        <div id={"panel-container"} className={this.props.scrubber_expanded}>
          <Panel
            {...this.state.panelData}
            title={this.state.panelData.title}
            key={this.state.panelData.content.key}
            closePanelCallback={this.state.panelData.closeCallback}
          />
        </div>
      );
    }
    return panel;
  }
}

export default PanelContainer;
